import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import axios from 'axios';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const base = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
      const { data } = await axios.post(`${base}/api/auth/login`, { username: email, password });
      localStorage.removeItem('techAuthenticated');
      // Clear any tech-portal identity left over from a prior tech login on this
      // browser -- otherwise an admin session inherits that stale tech's name
      // (e.g. "Technician 1") everywhere the tech app reads these keys, not just
      // on TechDashboard's own header. See scheduler-memory for the incident.
      localStorage.removeItem('technicianName');
      localStorage.removeItem('techUser');
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('userRole', 'admin');
      localStorage.setItem('isAuthenticated', 'true');
      navigate('/dashboard');
    } catch (err) {
      const msg = err?.response?.data?.detail;
      setError(msg === 'Invalid credentials' ? 'Invalid username or password.' : (msg || 'Could not connect. Try again.'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8 border-t-4" style={{ borderTopColor: '#1b7abf' }}>
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img src="/aaa-logo.png" alt="AAA Irrigation Service" className="h-20 w-auto" />
          </div>

          {/* Title */}
          <div className="text-center mb-8">
            <h1
              className="text-2xl uppercase italic tracking-tight mb-2"
              style={{ fontFamily: "'Inter', sans-serif", fontWeight: 900, color: '#1b7abf' }}
            >
              AAA Irrigation Service
            </h1>
            <p className="text-gray-500">Field Technician Sign In</p>
          </div>

          {/* Login Form */}
          <form onSubmit={handleLogin}>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Username</label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <Input
                    type="text"
                    placeholder="your username"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="pl-10 h-12 bg-gray-50 border-gray-200"
                    required
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <Input
                    type="password"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="pl-10 h-12 bg-gray-50 border-gray-200"
                    required
                  />
                </div>
              </div>

              {error && (
                <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2 text-center">
                  {error}
                </p>
              )}

              <Button
                type="submit"
                className="w-full h-12 text-white"
                style={{ backgroundColor: '#ea580c' }}
                disabled={isLoading}
              >
                {isLoading ? 'Signing in...' : 'Sign in'}
              </Button>
            </div>
          </form>

          {/* Footer */}
          <p className="text-center text-xs text-gray-400 mt-6">
            Powered by Boatman Systems™
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;